import React from 'react'
import classnames from 'classnames'

import { propStyles } from '../layout/util'
import * as layoutStyles from '../layout/layout.styles'

export const Icon = ({ type, ...props }) => {
  const { classes, props: newprops } = propStyles(props)
  return <div className={classnames(layoutStyles[`icon${type}`], classes)} {...newprops} />
}
